// GENERATED FILE — do not edit, do not commit.
// Written by scripts/write-build-stamp.js on prebuild / prestart / pretest.
// The matching value is served at /build.json; a mismatch means this tab is
// running a bundle older than what is deployed.
export const BUILD_ID = '2cdf6af-1793709698';
